import { render } from "./TheAdminLayout.vue?vue&type=template&id=460cb3bb"
import script from "./TheAdminLayout.vue?vue&type=script&lang=js"
export * from "./TheAdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__